import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getItem, removeItem } from '~helpers/storage';
import { storageNames } from '~constants/storage';
import * as actions from '~actions/payment';
import generatePath from '~settings/routing';

const mapDispatchToProps = dispatch => ({
  setSelectedPropertiesIds: params => {
    dispatch(actions.setSelectedPropertiesIds(params));
  },
});

@withRouter
@connect(null, mapDispatchToProps)
export default class paymentCallback extends React.Component {
  componentDidMount() {
    const properties = getItem(storageNames.paymentsetupProperties);
    this.props.setSelectedPropertiesIds(properties || []);
    removeItem(storageNames.paymentsetupProperties);

    const search = queryString.parse(this.props.location.search);
    this.props.history.push(generatePath('paymentReceivingPayments', {}, search));
  }

  render() {
    return <div />;
  }
}

paymentCallback.propTypes = {
  setSelectedPropertiesIds: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};

paymentCallback.defaultProps = {
  setSelectedPropertiesIds: () => {},
  history: {
    push: () => {},
  },
  location: {
    search: '',
  },
};
